import React from "react";
import { makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DialogWhatsapp from "./dialogWhatsapp";

//#region Estilos
const useStyles = makeStyles<Theme, {}>({
    botonWhatsapp: {
        display: "block",
        width: "60px",
        height: "55px",
        color: "#fff",
        position: "fixed",
        right: "20px",
        bottom: "40px",
        borderRadius: "5%",
        lineHeight: "55px",
        textAlign: "center",
        zIndex: 999,
        background: "transparent"
    }
});
//#endregion Estilos

const BtnWhatsapp = () => {

    const classes = useStyles();
    const [openDialogWhatsapp, setOpenDialogWhatsapp] = React.useState(false);


    const handleOpenDialog  = () => {
        setOpenDialogWhatsapp(true);
    };
    const handleCloseDialog  = () => {
        setOpenDialogWhatsapp(false);
    };

    return (
        <>
            <body className={classes.botonWhatsapp}>
                <IconButton
                    aria-label="toggle visibility"
                    style={{ fontSize: '50px', background:'#ebebeb' }} 
                >
                    <WhatsAppIcon
                        onClick={() => handleOpenDialog()}
                        style={{ fontSize: 'inherit', color:'#00A884' }} 
                    />
                </IconButton>

                <DialogWhatsapp open={openDialogWhatsapp} handleClose={handleCloseDialog}></DialogWhatsapp>
            </body>
        </>
    );
    
};

export default BtnWhatsapp;